module.exports = __webpack_public_path__ + "static/SLFCspread-8-b0b0df03f50f587610ac8382d5db7dcf.jpg";